<template>
  <Card dis-hover>
    <div slot="title">
      <slot name="title"></slot>
      <p class="title-item">{{ this.$t('common.this_month') }}</p>
    </div>
    <a href="#" slot="extra">
      <slot name="extra"></slot>
    </a>
    <div class="top-line">
      <p>
        <!-- <span class="title">{{ $t('common.distribution_of_patrol') }}</span>
        <Icon
          size="16"
          :title="$t('common.distribution_of_patrol_desc')"
          type="ios-information-circle-outline"
        /> -->
      </p>
      <Select style="width: 120px" v-model="currentSelectType" :transfer="false" @on-change="onSelectType">
        <Option v-for="item in selectTypes" :value="item.type" :key="item.type">{{ $t(item.name) }}</Option>
      </Select>
    </div>
    <div id="ncontent"></div>
    <Spin size="large" v-show="isLoading" fix>
      {{ $t('common.loading_data') }}
    </Spin>
    <div v-if="!isLoading && (!startTimeDistributionData || startTimeDistributionData.length === 0)" class="no-data">
      {{ $t('common.no_data') }}
    </div>
  </Card>
</template>
<script>
import * as echarts from 'echarts';
import api from '../../../api/home/index';

export default {
  data() {
    return {
      sortWay: 'top',
      selectTypes: [
        { type: 1, name: 'common.byHour' },
        { type: 2, name: 'common.byDay' },
        { type: 3, name: 'common.byWeek' },
      ],
      currentSelectType: 1,
      isLoading: true,
      startTimeDistributionData: [],
      dateType: 1,
      getStartTimeDistributionParamArr: [],
      myChart: null,
    };
  },

  mounted() {
    this.init();
  },
  methods: {
    async init() {
      let resStart = await api.getStartTimeDistributionConfig();
      this.dateType = resStart.dateType;
      let params = {
        timeRange: 5,
        tagIdList: [],
        sourceTypeList: [],
        showCompare: 0,
        deptNode: [],
        checkerType: 2,
        role: [],
        user: [],
        templateId: [],
        sort: 'desc',
      };
      await this.getStartTimeDistribution(params);
      this.isLoading = false;
    },
    myEchartsResize() {
      this.myChart && this.myChart.resize();
    },
    async getStartTimeDistribution(param) {
      let paramArr = {};
      if (param) {
        paramArr = param;
      } else {
        paramArr = this.getStartTimeDistributionParamArr;
      }

      let resData = await api.getStartTimeDistribution(paramArr);
      this.startTimeDistributionData = resData;
      this.getStartTimeDistributionParamArr = paramArr;
    },
    updateChart(newVal) {
      newVal = newVal ? newVal : [];
      let timeArr = [];
      let dataArr = [];
      let _hours = [];
      switch (this.currentSelectType) {
        case 1:
          for (let i = 0; i < 24; i++) {
            _hours.push({
              diffType: i,
              times: 0,
            });
          }
          _hours.forEach(item => {
            newVal.forEach(val => {
              if (Number(val.diffType) == item.diffType) {
                item.times = val.times;
              }
            });
          });
          timeArr = _hours.map(item => item.diffType + this.$t('common.hourSuffix'));
          dataArr = _hours.map(item => item.times);
          break;
        case 2:
          timeArr = newVal.map(item => item.diffType);
          dataArr = newVal.map(item => item.times);
          break;
        case 3:
          timeArr = newVal.map(item => item.diffType);
          dataArr = newVal.map(item => item.times);
          break;
      }
      // 基于准备好的dom，初始化echarts实例
      let myChart = echarts.init(document.getElementById('ncontent'), null, { renderer: 'svg' });
      let option = {
        color: ['#FBA155'],
        grid: {
          left: '9%',
          top: '9%',
          right: '6%',
          bottom: '9%',
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          data: timeArr,
          axisTick: {
            show: true,
            alignWithLabel: true,
          },
          axisLabel: {
            fontSize: '12',
          },
          axisLine: {
            show: false,
          },
          splitLine: {
            show: false,
          },
        },
        yAxis: {
          type: 'value',
          minInterval: 1,
          splitLine: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
        },
        // dataZoom: {
        //   start: 32,
        //   end: 90,
        //   type: 'slider',
        //   handleSize: '70%',
        //   showDetail: false,
        // },
        series: [
          {
            data: dataArr,
            type: 'bar',
            barWidth: '50%',
            showBackground: true,
            itemStyle: {
              borderRadius: 3,
            },
            label: {
              show: true,
              position: 'top',
            },
            backgroundStyle: {
              color: 'rgba(180, 180, 180, 0.2)',
            },
          },
        ],
      };
      // 绘制图表
      myChart.setOption(option);
      this.myChart = myChart;
    },
    async onSelectType(e) {
      this.isLoading = true;
      await api.saveStartTimeDistributionConfig({
        dateType: e,
      });
      this.isLoading = false;
      await this.getStartTimeDistribution();
    },
  },
  watch: {
    startTimeDistributionData(newVal) {
      this.updateChart(newVal);
    },
    dateType(newVal) {
      this.currentSelectType = newVal;
      this.updateChart(this.startTimeDistributionData);
    },
  },
};
</script>
<style lang="less" scoped>
::v-deep {
  .ivu-card-head p {
    width: auto;
  }
}
.title-item {
  padding: 0 5px;
  height: 18px;
  background: #f0f0f0;
  border-radius: 3px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  font-size: 12px;
  color: #b2b2b2;
  letter-spacing: 0;
  line-height: 16px;
  text-align: center;
  margin-left: 6px;
}
.top-line {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .title {
    flex-shrink: 0;
    display: inline-block;
    margin-right: 5px;
    font-weight: 600;
    font-size: 16px;
    color: #333333;
  }
}
#ncontent {
  width: 100%;
  height: 100%;
  position: relative;
  bottom: 10px;
}
</style>
